import {
  deleteStoredTopupOrigin,
  getStoredTopupOrigin,
} from "../utils/storage";
import {
  MOBILE_APP_TO_WEB_APP_ROUTE_MAP,
  TopupOrigins,
} from "../utils/constants";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

export default function usePaymentRedirect() {
  const navigate = useNavigate();
  const topupOrigin = getStoredTopupOrigin();

  const handlePaymentRedirect = useCallback(
    (webPath: string) => {
      if (topupOrigin === TopupOrigins.WEB) navigate(webPath);
      else window.location.href = MOBILE_APP_TO_WEB_APP_ROUTE_MAP[webPath];
      deleteStoredTopupOrigin();
    },
    [topupOrigin, navigate]
  );

  return { handlePaymentRedirect };
}
